angular.module('env.customConfig.configs', [
    'env.customConfig.provider',
    'env.customConfig.logicResolvers',
    'env.customConfig.workflow',
    'env.custom.customModule'
])
    .config(function ($customisationConfigProvider,
        $customLogicResolversProvider,
        centreUserWorkflowConfig,
        customerUserWorkflowConfig,
        $customActionsProvider) {
        $customisationConfigProvider.configs =
            [
                {
                    //List of the reports to be shown on the Orders gridview toolbar's dropdown button
                    //those reports should be configured in the configReports.js configuration file
                    name: "orders-grid-reports",
                    options: [
                        {
                            //for DelcamSupport user
                            value: ["overnight-orders-overview", "orders-month-overview", "orders-by-mid-layer", "orders-by-date", "orders-by-date-2yrs"],
                            condition: function (context) {
                                //Show the above reports collection only for DelcamSupport user
                                return context.user.name === 'DelcamSupport';
                            }
                        },
                        {
                            //for centre user
                            value: ["overnight-orders-overview", "orders-month-overview", "orders-by-mid-layer", "orders-by-date", "orders-by-date-2yrs"],
                            //value: ["orders-by-iqube-user", "orders-by-ipad-user", "orders-by-iqube-user-new", "orders-by-ipad-user-new"],
                            //value: ["multi-orders", "daily-report", "orders-by-customer", "orders-by-date"],
                            condition: function (context) {
                                //Show the above reports collection only for Centre (Lab) users
                                return context.user.role.isCentre;
                            }
                        },
                        {
                            //for customer user
                            //can be a different report for a customer user
                            //(or removed at all if you want to show the same as for centre user, see example below)
                            value: ["orders-report-general", "show-audit"],
                            condition: function (context) {
                                //Hide all reports for customer users for now
                                return false;//context.user.role.isCustomer;
                            }
                        }
                    ]
                },
                {
                    //List of the reports to be shown on the Order Details's page (if needed)
                    //those reports should be configured in the configReports.js configuration file
                    name: "order-reports",
                    options: [
                        {
                            //for customer user
                            value: [],
                            condition: function (context) {
                                //Show the above reports collection only for Centre users
                                return context.user.role.isCustomer;
                            }
                        },
                        {
                            value: ["order-label", "order-pair-label", "lab-order-report", "order-report", "order-certificate"],
                            condition: function (context) {
                                //Show the above reports collection only for specific users
                                return context.user.name === 'DelcamSupport';
                            }
                        },
                        {
                            value: ["order-label", "order-pair-label", "lab-order-report", "order-certificate"],
                            condition: function (context) {
                                //Show the above reports collection only for Centre users
                                return context.user.role.isCentre;
                            }
                        }
                    ]
                },
                {
                    //Main shell config to instruct app to hide the navbar menu and/or allow view order details
                    name: "shell-config",
                    options: [
                        {
                            value: {
                                hideMenu: false,
                                forbidOrderDetailsView: false,
                                newOrderAllowed: false
                            },
                            condition: function (context) {
                                return context.user.role.isCentre;
                            }
                        },
                        {
                            value: {
                                hideMenu: true,
                                forbidOrderDetailsView: true,
                                newOrderAllowed: false
                            },
                            condition: function (context) {
                                return context.user.role.isCustomer;
                            }
                        }
                    ]
                },
                {
                    name: "spinner-config",
                    options: [
                        {
                            value: {
                                type: "dots"
                            }
                        }
                    ]
                },
                {
                    name: "grid-config",
                    resolve: function (context) {
                        //Tries to resolve the uri to the configuration file and then to download and evaluate it.
                        //If succeeded, the resulted configuration object as a proper javascript object instance will be returned.
                        return $customLogicResolversProvider.resolveConfigFromServer(context, this.name + ".js", om.config.grid.defaultConfiguration);
                    }
                },
                {
                    name: "workflow-config",
                    options: [
                        {
                            value: customerUserWorkflowConfig,
                            condition: function (context) {
                                return context.user.role.isCustomer;
                            }
                        },
                        {
                            value: centreUserWorkflowConfig,
                            condition: function (context) {
                                return context.user.role.isCentre;
                            }
                        }
                    ]
                },
                {
                    name: "left-panel-custom-links-config",
                    options: [
                        {
                            value: [],
                            condition: function (context) {
                                return context.user.role.isCustomer;
                            }
                        },
                        {
                            value: [
                                {
                                    href: '#/client/centres',
                                    iconClass: 'icon-organization hover-highlight',
                                    title: 'Centres'
                                },
                                {
                                    href: '#/client/statistics',
                                    iconClass: 'icon-chart hover-highlight',
                                    title: 'Statistics'
                                },
                                {
                                    href: '#/client/assetsRegister',
                                    iconClass: 'icon-screen-tablet hover-highlight',
                                    title: 'Assets'
                                }
                            ],
                            condition: function (context) {
                                return context.user.role.isCentre;
                            }
                        }
                    ]
                },
                {
                    name: "centre-profile-open-orders-filter",
                    resolve: function (context) {
                        if (!context.user.role.isCentre || angular.isUndefined(context.centreId)) {
                            return null;
                        }
                        return {
                            name: context.centreCode,
                            color: 'green',
                            queryForStatInfo:
                                `OrderItem.Deleted = false AND Step.Code <> 'Shipped' AND Step.Code <> 'Complete' AND Step.Code <> 'Cancelled' AND (Centre.Id = ${context.centreId} OR AssignedCentre.Id = ${context.centreId})`,
                            targetUri: `#/client/centres/${context.centreId}/overview`,
                            iconName: 'track',
                            uiPriority: 1
                        };
                    }
                },
                {
                    name: "customer-profile-open-orders-filter",
                    resolve: function (context) {
                        if (!context.user.role.isCentre || angular.isUndefined(context.customerId)) {
                            return null;
                        }
                        return {
                            name: context.customerCode,
                            color: 'green',
                            queryForStatInfo: `OrderItem.Deleted = false AND Step.Code <> 'Shipped' AND Step.Code <> 'Complete' AND Step.Code <> 'Cancelled' AND Customer.Id = ${context.customerId}`,
                            targetUri: `#/client/customers/${context.customerId}/overview`,
                            iconName: 'track',
                            uiPriority: 1
                        };
                    }
                },
                {
                    name: "customer-profile-completed-orders-filter",
                    resolve: function (context) {
                        if (!context.user.role.isCentre || angular.isUndefined(context.customerId)) {
                            return null;
                        }
                        return {
                            name: context.customerCode,
                            color: 'red',
                            queryForStatInfo: `OrderItem.Deleted = false AND Step.Code <> 'Cancelled' AND Customer.Id = ${context.customerId}`,
                            targetUri: `#/client/customers/${context.customerId}/overview`,
                            iconName: 'track',
                            uiPriority: 1
                        };
                    }
                },
                {
                    name: "order-item-card-barcode-scanner-custom-action",
                    resolve: function (context) {
                        return function () {
                            if (!angular.isUndefined($customActionsProvider) && $customActionsProvider.handOutLeftFootScanFile) {
                                $customActionsProvider.handOutLeftFootScanFile(context.orderItem);
                            }
                        };
                    }
                },
                {
                    name: "order-item-card-page-title-getter",
                    resolve: function (context) {
                        return function () {
                            if (context.orderItem) {
                                return 'OrderManager: Order ' + context.orderItem.$model.order.$model.id;
                            }
                            return null;
                        };
                    }
                },
                {
                    name: "new-order-config",
                    resolve: function () {
                    }
                },
                {
                    name: "new-order-types-config",
                    resolve: function () {
                    }
                },
                {
                    name: "defaultUserSettings-config",
                    options: [
                        {
                            value: {
                                version: 1,
                                gridSettings: {
                                    textSearchFields: [
                                        {
                                            "text": "Order Item", "checked": true, "expanded": true, "items": [
                                                { "text": "Id", "alias": "OrderItem.Id", "type": "int", "checked": false },
                                                { "text": "Data", "alias": "OrderItem.Data", "checked": false },
                                                { "text": "Completed", "alias": "OrderItem.Completed", "type": "date", "checked": false },
                                                { "text": "Expected by", "alias": "OrderItem.ExpectedBy", "type": "date", "checked": false },
                                                { "text": "Required by", "alias": "OrderItem.RequiredBy", "type": "date", "checked": false },
                                                { "text": "Summary", "alias": "OrderItem.Summary", "checked": true },
                                                { "text": "Custom fields", "customFields": "OrderItem", "checked": true },
                                                { "text": "Step", "alias": "Step.Code", "checked": false },
                                                {
                                                    "text": "Assigned Centre", "checked": false, "items": [
                                                        { "text": "Code", "alias": "AssignedCentre.Code", "checked": false },
                                                        {
                                                            "text": "Address", "alias": "AssignedCentreAddress", "checked": false, "items": [
                                                                { "text": "Line 1", "alias": "Line1", "checked": false },
                                                                { "text": "Line 2", "alias": "Line2", "checked": false },
                                                                { "text": "City", "alias": "City", "checked": false },
                                                                { "text": "Company Name", "alias": "CompanyName", "checked": false },
                                                                { "text": "Contact last name", "alias": "ContactLastName", "checked": false },
                                                                { "text": "Contact first name", "alias": "ContactFirstName", "checked": false },
                                                                { "text": "Contact title", "alias": "ContactTitle", "checked": false },
                                                                { "text": "Country", "alias": "Country", "checked": false },
                                                                { "text": "Email", "alias": "Email", "checked": false },
                                                                { "text": "Postal code", "alias": "PostalCode", "checked": false },
                                                                { "text": "Region", "alias": "Region", "checked": false },
                                                                { "text": "Telephone", "alias": "Telephone", "checked": false }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "text": "Created By", "alias": "CreatedBy", "checked": true, "items": [
                                                        { "text": "Name", "alias": "Name", "checked": true },
                                                        { "text": "Last name", "alias": "LastName", "checked": true },
                                                        { "text": "First name", "alias": "FirstName", "checked": true },
                                                        { "text": "Title", "alias": "Title", "checked": true },
                                                        { "text": "Email", "alias": "Email", "checked": true }
                                                    ]
                                                },
                                                {
                                                    "text": "Order", "checked": false, "items": [
                                                        { "text": "Id", "alias": "Order.Id", "type": "int", "checked": true },
                                                        { "text": "Reference", "alias": "Order.Reference", "checked": true },
                                                        { "text": "Summary", "alias": "Order.Summary", "checked": true },
                                                        { "text": "Data", "alias": "Order.Data", "checked": false },
                                                        { "text": "Completed", "alias": "Order.Completed", "type": "date", "checked": false },
                                                        { "text": "Expected by", "alias": "Order.ExpectedBy", "type": "date", "checked": false },
                                                        { "text": "Required by", "alias": "Order.RequiredBy", "type": "date", "checked": false },
                                                        { "text": "Custom fields", "customFields": "Order", "checked": false },
                                                        {
                                                            "text": "Centre", "checked": false, "items": [
                                                                { "text": "Code", "alias": "Centre.Code", "checked": false },
                                                                {
                                                                    "text": "Address", "alias": "CentreAddress", "checked": false, "items": [
                                                                        { "text": "Line 1", "alias": "Line1", "checked": false },
                                                                        { "text": "Line 2", "alias": "Line2", "checked": false },
                                                                        { "text": "City", "alias": "City", "checked": false },
                                                                        { "text": "Company Name", "alias": "CompanyName", "checked": false },
                                                                        { "text": "Contact last name", "alias": "ContactLastName", "checked": false },
                                                                        { "text": "Contact first name", "alias": "ContactFirstName", "checked": false },
                                                                        { "text": "Contact title", "alias": "ContactTitle", "checked": false },
                                                                        { "text": "Country", "alias": "Country", "checked": false },
                                                                        { "text": "Email", "alias": "Email", "checked": false },
                                                                        { "text": "Postal code", "alias": "PostalCode", "checked": false },
                                                                        { "text": "Region", "alias": "Region", "checked": false },
                                                                        { "text": "Telephone", "alias": "Telephone", "checked": false }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "text": "Customer", "checked": false, "items": [
                                                                { "text": "Code", "alias": "Customer.Code", "checked": false },
                                                                { "text": "Address", "alias": "CustomerAddress", "checked": false, "items": [
                                                                        { "text": "Line 1", "alias": "Line1", "checked": false },
                                                                        { "text": "Line 2", "alias": "Line2", "checked": false },
                                                                        { "text": "City", "alias": "City", "checked": false },
                                                                        { "text": "Company Name", "alias": "CompanyName", "checked": false },
                                                                        { "text": "Contact last name", "alias": "ContactLastName", "checked": false },
                                                                        { "text": "Contact first name", "alias": "ContactFirstName", "checked": false },
                                                                        { "text": "Contact title", "alias": "ContactTitle", "checked": false },
                                                                        { "text": "Country", "alias": "Country", "checked": false },
                                                                        { "text": "Email", "alias": "Email", "checked": false },
                                                                        { "text": "Postal code", "alias": "PostalCode", "checked": false },
                                                                        { "text": "Region", "alias": "Region", "checked": false },
                                                                        { "text": "Telephone", "alias": "Telephone", "checked": false }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "text": "Delivery address", "alias": "DeliveryAddress", "checked": true, "items": [
                                                                { "text": "Line 1", "alias": "Line1", "checked": true },
                                                                { "text": "Line 2", "alias": "Line2", "checked": true },
                                                                { "text": "City", "alias": "City", "checked": true },
                                                                { "text": "Company Name", "alias": "CompanyName", "checked": true },
                                                                { "text": "Contact last name", "alias": "ContactLastName", "checked": true },
                                                                { "text": "Contact first name", "alias": "ContactFirstName", "checked": true },
                                                                { "text": "Contact title", "alias": "ContactTitle", "checked": true },
                                                                { "text": "Country", "alias": "Country", "checked": true },
                                                                { "text": "Email", "alias": "Email", "checked": true },
                                                                { "text": "Postal code", "alias": "PostalCode", "checked": true },
                                                                { "text": "Region", "alias": "Region", "checked": true },
                                                                { "text": "Telephone", "alias": "Telephone", "checked": true }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                orderItemCardTab: "updates",
                                saveOrderItemCardTab: true,
                                disableCookiePolicyWarning: true
                            }
                        }
                    ]
                }
            ];
    })
    ;
